<div class="page-container" animate.enter="route-slide-in-right" animate.leave="route-slide-out-right">
  <app-card>
    <app-card-header>
      <app-card-title>
        <div class="flex flex-align-center gap-sm">
          <app-back-button [ariaLabel]="'settings.back' | translate" />
          <span>{{ 'settings.tags.title' | translate }}</span>
        </div>
      </app-card-title>
    </app-card-header>
    <app-card-content>
      @if (tags().length === 0) {
        <p class="empty-state" data-testid="tags-empty">{{ 'settings.tags.empty' | translate }}</p>
      } @else {
        <ul class="tag-list" data-testid="tag-list">
          @for (tag of tags(); track tag.id) {
            <li class="tag-row flex flex-align-center flex-justify-space-between gap-sm" [attr.data-testid]="'tag-row-' + tag.id">
              <div class="flex flex-align-center gap-sm">
                <app-tag-chip [tag]="tag" />
                @if (tag.category) {
                  <span class="tag-category">{{ tag.category }}</span>
                }
                @if (!tag.is_active) {
                  <span class="tag-inactive-badge">{{ 'settings.tags.inactive' | translate }}</span>
                }
              </div>
              <div class="flex gap-xs">
                <app-button variant="text" (click)="toggleActive(tag)" [attr.data-testid]="'toggle-tag-' + tag.id">
                  {{ (tag.is_active ? 'settings.tags.deactivate' : 'settings.tags.activate') | translate }}
                </app-button>
                <app-button variant="text" (click)="openEdit(tag)" [attr.data-testid]="'edit-tag-' + tag.id">
                  <app-icon name="pencil" [size]="14" />
                </app-button>
              </div>
            </li>
          }
        </ul>
      }
    </app-card-content>
    <app-card-actions>
      <app-button variant="filled" (click)="openCreate()" data-testid="new-tag-button">
        <app-icon name="plus" />
        {{ 'settings.tags.new' | translate }}
      </app-button>
    </app-card-actions>
  </app-card>
</div>

@if (showEditor()) {
  <app-modal-dialog (backdropClick)="closeEditor()">
    <div header>
      <div class="heading-md">{{ (editing() ? 'settings.tags.editTitle' : 'settings.tags.newTitle') | translate }}</div>
    </div>
    <div content>
      @if (error()) {
        <div class="error-container p-md" data-testid="tag-form-error">{{ error() }}</div>
      }
      <form [formGroup]="form">
        <formly-form [form]="form" [fields]="fields" [model]="model" />
      </form>
    </div>
    <div footer>
      <app-button variant="text" (click)="closeEditor()" data-testid="cancel-tag-button">
        {{ 'settings.tags.cancel' | translate }}
      </app-button>
      <app-button variant="filled" color="primary" [disabled]="saving()" (click)="save()" data-testid="save-tag-button">
        {{ 'settings.tags.save' | translate }}
      </app-button>
    </div>
  </app-modal-dialog>
}
